<template>
  <!-- eslint-disable -->
  <div class="message-item">
    <div>
      <v-text-field
        v-model.number="node.delay"
        class="mb-3 panzoom-ignore"
        type="number"
        :label="$t('shortcodes.live_chat_mp4.delay_ms')"
        persistent-placeholder
        placeholder="0"></v-text-field>
    </div>
    <div>
      <v-text-field
        class="message-item__settings--delay panzoom-ignore"
        v-model="node.buttonText"
        :label="'Button text'"
        persistent-placeholder
        :placeholder="'Confirm'"></v-text-field>
    </div>
    <div>
      <VaColorPicker
        class="mb-4 panzoom-ignore"
        :title="'Button background color'"
        :mode="'hex'"
        hide-alpha-slider
        v-model="node.buttonColor"></VaColorPicker>
    </div>
    <div>
      <v-text-field
        class="message-item__settings--delay panzoom-ignore"
        v-model="node.placeholderText"
        :label="'Placeholder text'"
        persistent-placeholder
        :placeholder="'e.g., 12345'"></v-text-field>
    </div>
    <div>
      <v-select
        v-model="node.zipInputDisplayType"
        :items="zipInputTypes"
        :label="$t('shortcodes.live_chat_auto.input_question_display_type')"
        persistent-placeholder
        :placeholder="'Select input type'" />
    </div>
    <div>
      <v-radio-group v-model="overrideMode" class="mb-3 radio-group-override">
        <v-radio
          label="Override ZIP only"
          :value="ZIP_OVERRIDE_MODE.ZIP_ONLY"
          color="primary"
          hide-details="auto">
        </v-radio>
        <v-radio
          label="Override ZIP and auto-determine City & State"
          :value="ZIP_OVERRIDE_MODE.ZIP_AND_LOCATION"
          color="primary"
          hide-details="auto">
        </v-radio>
      </v-radio-group>
    </div>
  </div>
</template>

<script>
  import VaColorPicker from "@/components/custom/VaColorPicker";
  import { ZIP_INPUT_DISPLAY_TYPES, ZIP_OVERRIDE_MODE } from "./constant";

  export default {
    name: "LiveChatMp4ZipInput",
    components: { VaColorPicker },

    props: {
      node: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        zipInputTypes: ZIP_INPUT_DISPLAY_TYPES,
        ZIP_OVERRIDE_MODE,
      };
    },
    computed: {
      overrideMode: {
        get() {
          if (this.node.overrideZipAndLocation) return ZIP_OVERRIDE_MODE.ZIP_AND_LOCATION;
          if (this.node.overrideZipOnly) return ZIP_OVERRIDE_MODE.ZIP_ONLY;
          return ZIP_OVERRIDE_MODE.ZIP_ONLY; // default
        },
        set(value) {
          this.node.overrideZipOnly = value === ZIP_OVERRIDE_MODE.ZIP_ONLY;
          this.node.overrideZipAndLocation = value === ZIP_OVERRIDE_MODE.ZIP_AND_LOCATION;
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";

  .message-item__label {
    @include text-caption-bold();
    color: get-color("subtitle");
    margin-bottom: 10px;
  }

  .radio-group-override {
    margin-top: 0 !important;
  }

  ::v-deep .v-radio {
    .v-label {
      @include text-body-2();
      color: var(--v-body-base) !important;
    }
  }
</style>
